export default "__VITE_ASSET__1ae74a36__"